import React, { useState, useEffect } from "react";
import { 
  Table, 
  Button, 
  Modal, 
  Form, 
  Input, 
  Select, 
  Switch, 
  Space, 
  Popconfirm,
  message,
  Card,
  Row,
  Col,
  Typography,
  Tooltip,
  Tag,
  Tabs,
  Spin
} from 'antd';
import { 
  PlusOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  UpOutlined,
  DownOutlined,
  MenuOutlined,
  AppstoreOutlined,
  TeamOutlined,
  LinkOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  MinusOutlined
} from '@ant-design/icons';
import Api from "../../../services/api";

const { Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { TabPane } = Tabs;

function Menu() {
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('cms');
    const [menu, setMenu] = useState({
        cms: [],
        studio: []
    });
    const [countMenu, setCountMenu] = useState({ menuCms: 0, menuStudio: 0 });
    const [showModal, setShowModal] = useState(false);
    const [currentEdit, setCurrentEdit] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [rawMenuData, setRawMenuData] = useState([]);
  const [form] = Form.useForm();
  const [expandedRows, setExpandedRows] = useState([]);

    
    const fetchMenus = async () => {
        setLoading(true);
        try {
            const result = await Api.get('/api/menu');
            if (result.data.code === 0) {
                setRawMenuData(result.data.data);

                const cmsMenus = result.data.data[0] ? [
                    ...(result.data.data[0].menu_app_detail || []),
                    ...(result.data.data[0].menu_overview || [])
                ] : [];
                
                const studioMenus = result.data.data[1] ? [
                    ...(result.data.data[1].menu_app_detail || []),
                    ...(result.data.data[1].menu_overview || [])
                ] : [];

                setMenu({
                    cms: cmsMenus,
                    studio: studioMenus
                });
                
                countMenuData({
                    cms: cmsMenus,
                    studio: studioMenus
                });

                
                const autoExpandMenus = (menuList) => {
                    const expandedKeys = [];
                    menuList.forEach(menu => {
                        if (menu.child && menu.child.length > 0) {
                            expandedKeys.push(menu.id);
                        }
                    });
                    return expandedKeys;
                };

                
                const cmsExpandedKeys = autoExpandMenus(cmsMenus);
                const studioExpandedKeys = autoExpandMenus(studioMenus);
                
                
                const allExpandedKeys = [...cmsExpandedKeys, ...studioExpandedKeys];
                setExpandedRows(allExpandedKeys);
            } else {
        message.error("Lỗi lấy dữ liệu !!");
            }
        } catch (error) {
      message.error("Có lỗi xảy ra khi tải dữ liệu");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    
    const autoExpandCurrentTab = () => {
        const currentMenuData = activeTab === 'cms' ? menu.cms : menu.studio;
        const expandedKeys = [];
        currentMenuData.forEach(menu => {
            if (menu.child && menu.child.length > 0) {
                expandedKeys.push(menu.id);
            }
        });
        setExpandedRows(expandedKeys);
    };

    useEffect(() => {
        fetchMenus();
    }, []);

    
    useEffect(() => {
        if (menu.cms.length > 0 || menu.studio.length > 0) {
            autoExpandCurrentTab();
        }
    }, [activeTab, menu]);

    
    const countMenuData = (menuData) => {
        let totalCountCms = 0;
        let totalCountStudio = 0;

        if (menuData['cms'] && menuData['cms'].length > 0) {
            totalCountCms = menuData['cms'].filter(item =>
                !item.parent_id || item.parent_id === 0
            ).length;
        }

        if (menuData['studio'] && menuData['studio'].length > 0) {
            totalCountStudio = menuData['studio'].filter(item =>
                !item.parent_id || item.parent_id === 0
            ).length;
        }

        setCountMenu({
            menuCms: totalCountCms,
            menuStudio: totalCountStudio,
        });
    };

    
    const handleAddNew = () => {
        setCurrentEdit(null);
    form.resetFields();
        setShowModal(true);
    };

    
    const handleEdit = (menuItem) => {
        setCurrentEdit(menuItem);

        const findMenuInGroup = (menuGroup) => {
            const checkMenu = (menus) => {
                for (const menu of menus) {
                    if (menu.id === menuItem.id) return true;
                    if (menu.child && menu.child.length > 0 && checkMenu(menu.child)) {
                        return true;
                    }
                }
                return false;
            };

            return (menuGroup.menu_overview && checkMenu(menuGroup.menu_overview)) ||
                (menuGroup.menu_app_detail && checkMenu(menuGroup.menu_app_detail));
        };

    let isAdminValue = '0';
        const inCms = rawMenuData[0] && findMenuInGroup(rawMenuData[0]);
        const inStudio = rawMenuData[1] && findMenuInGroup(rawMenuData[1]);

        if (inStudio && !inCms) {
            isAdminValue = '1';
        }

    form.setFieldsValue({
            name: menuItem.name,
            url: menuItem.url,
            type: menuItem.type || '',
            parent_id: menuItem.parent_id || 0,
            icon: menuItem.icon || '',
            permission_code: menuItem.permission_code || '',
            description: menuItem.description || '',
            display: menuItem.display !== false,
            is_admin: isAdminValue
        });

        setShowModal(true);
    };

    
    const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
        setIsSubmitting(true);

            
            
            
            const isCmsGroup = String(values.is_admin) === '0';
            const payload = {
                ...values,
                display: values.display ? 1 : 0,
                is_admin: isCmsGroup ? 1 : 0
            };

            if (currentEdit) {
                await Api.put(`/api/menu/${currentEdit.id}`, payload);
        message.success("Cập nhật menu thành công");
            } else {
                await Api.post('/api/menu', payload);
        message.success("Thêm mới menu thành công");
            }

      await fetchMenus();
      setShowModal(false);
        } catch (error) {
            console.error('Lỗi khi lưu menu:', error);
      message.error("Có lỗi xảy ra khi lưu dữ liệu");
        } finally {
            setIsSubmitting(false);
        }
    };

    
    const getParentOptions = () => {
        const options = [];
        const selectedMenuGroup = form.getFieldValue('is_admin');
        const selectedMenuType = form.getFieldValue('type');

        
        if ((selectedMenuGroup === undefined || selectedMenuGroup === null) || !selectedMenuType) return [];

        const menuGroupData = rawMenuData[parseInt(selectedMenuGroup)];
        if (!menuGroupData) return [];

        const menuList = menuGroupData[selectedMenuType] || [];

        const addMenuItems = (items, level = 0) => {
            items.forEach(item => {
                if (currentEdit && item.id === currentEdit.id) return;

                options.push({
                    id: item.id,
                    name: item.name,
                    level: level
                });

                if (item.child && item.child.length > 0) {
                    addMenuItems(item.child, level + 1);
                }
            });
        };

        const parentMenus = menuList.filter(item => !item.parent_id || item.parent_id === 0);
        addMenuItems(parentMenus);

        return options;
    };

    const handleDelete = async (menuId) => {
        try {
            setLoading(true);
            const result = await Api.delete(`/api/menu/${menuId}`);

            if (result.data.code === 0) {
        message.success("Xóa menu thành công");
        await fetchMenus();
            } else {
        message.error(result.data.message || "Xóa menu thất bại");
            }
        } catch (error) {
            console.error('Lỗi khi xóa menu:', error);
      message.error("Có lỗi xảy ra khi xóa menu");
        } finally {
            setLoading(false);
        }
    };

    
    const handleSort = async (menuId, direction, parentId = null) => {
        try {
            setLoading(true);

            const result = await Api.put(`/api/menu/${menuId}/sort`, {
        direction: direction,
        parent_id: parentId
            });

            if (result.data.code === 0) {
        message.success("Sắp xếp menu thành công");
        await fetchMenus();
            } else {
        message.error(result.data.message || "Sắp xếp thất bại");
            }
        } catch (error) {
            console.error('Lỗi khi sắp xếp menu:', error);
      message.error("Có lỗi xảy ra khi sắp xếp");
        } finally {
            setLoading(false);
        }
    };

  const renderMenuTable = (menuData, menuType) => {
    let i = 0;
    
    const columns = [
      {
        title: 'Tên menu',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => (
          <span style={{ fontWeight: record.parent_id ? 'normal' : 'bold' }}>
            {record.parent_id ? (
              <span>
                <span style={{ color: '#999999', marginRight: '4px' }}>--</span>
                {text}
              </span>
            ) : text}
          </span>
        ),
      },
      {
        title: 'Icon',
        dataIndex: 'icon',
        key: 'icon',
        render: (text) => text ? <span>{text}</span> : '-',
      },
      {
        title: 'URL',
        dataIndex: 'url',
        key: 'url',
        render: (text) => text ? <span>{text}</span> : '-',
      },
      {
        title: 'Trạng thái',
        dataIndex: 'display',
        key: 'display',
        render: (display) => (
          <Tag color={display ? 'green' : 'red'}>
            {display ? (
              <Space>
                <EyeOutlined />
                Hiển thị
              </Space>
            ) : (
              <Space>
                <EyeInvisibleOutlined />
                Ẩn
              </Space>
            )}
          </Tag>
        ),
      },
      {
        title: 'Sắp xếp',
        key: 'sort',
        render: (_, record, index) => {
          i++;
          
          
          const isChildMenu = record.parent_id && record.parent_id !== 0;
          
          let isFirstInGroup = false;
          let isLastInGroup = false;
          
          if (isChildMenu) {
            
            const parentMenu = menuData.find(item => item.id === record.parent_id);
            if (parentMenu && parentMenu.child) {
              const childIndex = parentMenu.child.findIndex(child => child.id === record.id);
              isFirstInGroup = childIndex === 0;
              isLastInGroup = childIndex === parentMenu.child.length - 1;
            }
          } else {
            
            const parentIndex = menuData.findIndex(item => item.id === record.id);
            isFirstInGroup = parentIndex === 0;
            isLastInGroup = parentIndex === menuData.length - 1;
          }
          
          return (
            <Space>
              {!isFirstInGroup && (
                <Tooltip title="Di chuyển lên">
                  <Button
                    type="text"
                    icon={<UpOutlined />}
                    onClick={() => handleSort(record.id, 'up')}
                    disabled={loading}
                  />
                </Tooltip>
              )}
              {!isLastInGroup && (
                <Tooltip title="Di chuyển xuống">
                  <Button
                    type="text"
                    icon={<DownOutlined />}
                    onClick={() => handleSort(record.id, 'down')}
                    disabled={loading}
                  />
                </Tooltip>
              )}
            </Space>
          );
        },
      },
      {
        title: 'Hành động',
        key: 'action',
        render: (_, record) => (
          <Space size="middle">
            <Tooltip title="Chỉnh sửa">
              <Button 
                type="primary" 
                icon={<EditOutlined />} 
                size="small"
                onClick={() => handleEdit(record)}
              />
            </Tooltip>
            <Tooltip title="Xóa">
              <Popconfirm
                title="Bạn có chắc chắn muốn xóa menu này?"
                onConfirm={() => handleDelete(record.id)}
                okText="Có"
                cancelText="Không"
              >
                <Button 
                  type="primary" 
                  danger 
                  icon={<DeleteOutlined />} 
                  size="small"
                />
              </Popconfirm>
            </Tooltip>
          </Space>
        ),
      },
    ];

    const dataSource = menuData.map((item, index) => {
      const children = item.child && item.child.length > 0 ? 
        item.child.map((child, childIndex) => ({
          ...child,
          key: `child-${child.id}`,
          name: child.name,
          icon: child.icon,
          url: child.url,
          display: child.display,
        })) : [];

      return {
        ...item,
        key: item.id,
        children: children.length > 0 ? children : undefined,
      };
    });

    return (
      <div style={{ overflowX: 'auto' }}>
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          loading={loading}
          bordered
          scroll={{ x: 'max-content' }}
          expandable={{
            expandedRowKeys: expandedRows,
            onExpandedRowsChange: setExpandedRows,
            childrenColumnName: 'children',
          }}
        />
      </div>
    );
  };

  return (
    <>
      <div className="background-second-dashboard">
        <section className="main__content-dashbard">
          <div className="container-fluid">
            <Card>
              <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
                <Col>
                  <Title level={4} style={{ margin: 0, fontSize: '18px' }}>
                    Quản lý Menu
                  </Title>
                </Col>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<PlusOutlined />}
                    onClick={handleAddNew}
                    size="small"
                  >
                    Tạo Menu
                  </Button>
                </Col>
              </Row>

              <Tabs 
                activeKey={activeTab} 
                onChange={setActiveTab}
                items={[
                  {
                    key: 'cms',
                    label: (
                      <Space>
                        <AppstoreOutlined />
                        Menu CMS
                      </Space>
                    ),
                    children: renderMenuTable(menu.cms, 'cms'),
                  },
                  {
                    key: 'studio',
                    label: (
                      <Space>
                        <TeamOutlined />
                        Menu Studio
                      </Space>
                    ),
                    children: renderMenuTable(menu.studio, 'studio'),
                  },
                ]}
              />
            </Card>
          </div>
        </section>
      </div>

      <Modal
        title={currentEdit ? 'Chỉnh sửa Menu' : 'Thêm mới Menu'}
        open={showModal}
        onCancel={() => {
          setShowModal(false);
          form.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={isSubmitting}
        width={800}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            display: true,
            is_admin: '0',
            parent_id: 0
          }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Tên menu"
                                    name="name"
                rules={[{ required: true, message: 'Vui lòng nhập tên menu!' }]}
              >
                <Input placeholder="Nhập tên menu" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Đường dẫn"
                                    name="url"
              >
                <Input placeholder="Nhập đường dẫn" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="Mã quyền"
                                    name="permission_code"
              >
                <Input placeholder="Nhập mã quyền" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Icon"
                                    name="icon"
              >
                <Input placeholder="Nhập icon" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Trạng thái"
                name="display"
                valuePropName="checked"
              >
                <Switch 
                  checkedChildren="Hiển thị" 
                  unCheckedChildren="Ẩn" 
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="Loại menu"
                                    name="type"
                rules={[{ required: true, message: 'Vui lòng chọn loại menu!' }]}
              >
                <Select placeholder="Chọn loại menu" onChange={() => form.setFieldsValue({ parent_id: 0 })}>
                  <Option value="menu_overview">Menu chính</Option>
                  <Option value="menu_app_detail">Menu app</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Nhóm menu"
                                    name="is_admin"
                rules={[{ required: true, message: 'Vui lòng chọn nhóm menu!' }]}
              >
                <Select placeholder="Chọn nhóm menu" onChange={() => form.setFieldsValue({ parent_id: 0 })}>
                  <Option value="0">Menu CMS</Option>
                  <Option value="1">Menu Studio</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item shouldUpdate={(prev, cur) => prev.type !== cur.type || prev.is_admin !== cur.is_admin} noStyle>
                {() => (
                  <Form.Item
                    label="Danh mục cha"
                    name="parent_id"
                  >
                    <Select 
                      placeholder="Chọn danh mục cha"
                      disabled={!form.getFieldValue('type') || (form.getFieldValue('is_admin') === undefined || form.getFieldValue('is_admin') === null)}
                    >
                      <Option value={0}>-- Chọn danh mục cha --</Option>
                      {getParentOptions().map(option => (
                        <Option key={option.id} value={option.id}>
                          {option.level > 0 ? Array(option.level).fill('-- ').join('') : ''}{option.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Mô tả"
                                    name="description"
          >
            <TextArea rows={3} placeholder="Nhập mô tả" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default Menu;